import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'
import TemplateView from './components/Template.vue'

import ProductoView from './components/views/Producto.vue'
import MovimientoView from './components/views/Movimiento.vue'
import EtiquetaView from './components/views/Etiqueta.vue'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: TemplateView,
    children: [
      {
        path: 'movimientos',
        alias: '',
        component: MovimientoView,
        name: 'Movimientos',
        meta: {description: 'Movimientos de mercaderia', requiresAuth: true}
      }, {
        path: 'productos',
        component: ProductoView,
        name: 'Productos',
        meta: {description: 'Productos del sistema', requiresAuth: true}
      }, {
          path: 'etiquetas',
          component: EtiquetaView,
          name: 'Etiquetas',
          meta: {description: 'Etiquetas', requiresAuth: true}
        }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js